export const DATE_FORMAT = {
  LOCAL_DATE_FORMAT: "MM/DD/YYYY",
  LOCAL_SHORT_DATE_FORMAT: "MMDDYYYY",
  LOCAL_DATE_TIME_FORMAT: "MM/DD/YYYY hh:mm:ss A",
  ISO860_DATE_FORMAT: "YYYY-MM-DD",
  ISO860_SHORT_DATE_FORMAT: "YYYYMMDD"
};
